import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { STEP_RUN_LLM_USAGE_KEY } from '@/utils/queryKeys.ts';
import { get_step_run_llm_usage_url } from '@/utils/urls.ts';
import { LlmUsageSummary } from '@/types/llmUsage.ts';

const useRetrieveStepRunLlmUsage = (
  stepRunId?: string,
  enabled = true,
): UseQueryResult<LlmUsageSummary, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: STEP_RUN_LLM_USAGE_KEY(automationId, stepRunId),
    queryFn: async () => {
      const response = await apiClient.get<LlmUsageSummary>(get_step_run_llm_usage_url(stepRunId));
      return response.data;
    },
    enabled: !!stepRunId && enabled,
  });
};

export default useRetrieveStepRunLlmUsage;
